import React from 'react';




import Nosotross from '../screens/nosotro';




function Nosotros() {
    return (
      <div className="px-6 py-10 max-w-7xl mx-auto">
       
 

        <Nosotross/>




  
      </div>
    );
  }
  
  export default Nosotros;
  